export type QuestionFieldType =
  | "text"
  | "textarea"
  | "date"
  | "datetime-local"
  | "time"
  | "number"
  | "file"
  | "radio"
  | "checkbox";

export interface CustomQuestion {
  question: string;
  fieldType: QuestionFieldType;
  options?: string[];
  required?: boolean;
}

export type PostRegistrationAction = "toast" | "redirect";
export type CustomQuestionsPosition = "first" | "last";
export type PaymentCurrency = "EUR" | "USD" | "CHF";
export type EmailSendDelay =
  | "immediate"
  | "1hour"
  | "6hours"
  | "1day"
  | "2days";

export interface FieldConfig {
  visible: boolean;
  required: boolean;
}

export interface PhoneFieldConfig extends FieldConfig {
  requireVerification?: boolean;
}

export type PaymentType = "one-time" | "recurring";

export interface PaymentConfig {
  enabled: boolean;
  paymentType: PaymentType;
  description: string;
  amount: number;
  currency: PaymentCurrency;
  plan_code: string;
}

export interface EmailAttachment {
  name: string;
  size: number;
  type: string;
  url?: string;
}

export interface AutomatedEmailConfig {
  enabled: boolean;
  sendDelay: EmailSendDelay;
  subject: string;
  content: string;
  attachments: EmailAttachment[];
  _files?: File[];
}

export interface EsignatureRegistrationConfig {
  enabled: boolean;
  template_id: string;
  message: string;
  expiry_days: number;
}

export interface BookingRegistrationConfig {
  enabled: boolean;
  type_id: string;
}

export const BOOKING_DEFAULTS: BookingRegistrationConfig = {
  enabled: false,
  type_id: "",
};

export interface RegistrationFormData {
  requirePassword: boolean;
  formDescription?: string;
  fields: {
    user_last_name: FieldConfig;
    user_first_name: FieldConfig;
    user_phone: PhoneFieldConfig;
    user_country_code: FieldConfig;
    user_user_name: FieldConfig;
    user_birth_date: FieldConfig;
  };
  customQuestions: CustomQuestion[];
  customQuestionsPosition: CustomQuestionsPosition;
  postRegistrationAction: PostRegistrationAction;
  redirectUrl: string;
  paymentConfig: PaymentConfig;
  automatedEmail: AutomatedEmailConfig;
  esignature: EsignatureRegistrationConfig;
  booking: BookingRegistrationConfig;
}
